import { DataBean } from "../DataBean";


export class DOCTrdDocument extends DataBean {

    public async getDOCTrdDocument(iddoctrddocument: number): Promise<any> {
        return this.getCustomService("Forms", "com.advantage.forms.bean.DOCTrdDocument_getDOCTrdDocument_Number", [iddoctrddocument]);
    }

    public async getDOCTrdDocumentCatalogPorPropiedades(propiedades: Record<string, any>, maxRows: number): Promise<any> {
        return this.getCustomService("Forms", "java.util.List_getDOCTrdDocumentCatalogPorPropiedades_java.util.Map_Number", [propiedades, maxRows]);
    }

    public async updateDOCTrdDocument(bean: Record<string, any>): Promise<any> {
        return this.getCustomService("Forms", "com.advantage.forms.bean.DOCTrdDocument_updateDOCTrdDocument_com.advantage.forms.bean.DOCTrdDocument", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.advantage.forms.bean.DOCTrdDocument"
            }
        ]);
    }

}